import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { HiCheckBadge } from "react-icons/hi2";

const PHONE = "+91 99999 99999"; // ✅ replace
const WHATSAPP_NUMBER = "919999999999"; // ✅ replace
const WHATSAPP_TEXT = encodeURIComponent("Hi, I want a free consultation for GST/ITR/Compliance.");

export default function Hero() {
  const waHref = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;

  return (
    <section className="relative overflow-hidden">
      {/* subtle background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-navy-100 blur-3xl opacity-70" />
        <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-gold-100 blur-3xl opacity-60" />
      </div>

      <div className="mx-auto max-w-7xl container-pad">
        <div className="section grid items-center gap-10 lg:grid-cols-2">
          <div>
            {/* Single H1 for SEO */}
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl leading-tight text-navy-900">
              Trusted Chartered Accountant in India for{" "}
              <span className="text-navy-900 underline decoration-gold-500/60 underline-offset-8">
                Tax, GST & Compliance
              </span>
            </h1>

            <p className="mt-5 text-base sm:text-lg text-navy-800/80 max-w-xl">
              Clear guidance, on-time filings, and dedicated CA support—so you stay compliant and focus on growing your business.
              Serving startups, MSMEs, salaried professionals, and corporates across India.
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <span className="badge"><HiCheckBadge className="text-emeraldBrand-600" /> ICAI Registered</span>
              <span className="badge"><HiCheckBadge className="text-emeraldBrand-600" /> 10+ Years Experience</span>
              <span className="badge"><HiCheckBadge className="text-emeraldBrand-600" /> 1000+ Clients Served</span>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a href="#contact" className="btn-accent">
                Book Free Consultation
              </a>
              <div className="flex gap-3">
                <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="btn-secondary flex-1">
                  <FaPhoneAlt /> Call Now
                </a>
                <a href={waHref} target="_blank" rel="noreferrer" className="btn-primary flex-1">
                  <FaWhatsapp /> WhatsApp Us
                </a>
              </div>
            </div>

            <div className="mt-6 small-muted">
              <span className="font-medium text-navy-900">Quick start:</span> Share your requirement → get a checklist → we handle filing & follow-ups.
            </div>
          </div>

          <div className="relative">
            <div className="card overflow-hidden">
              <div className="p-4 sm:p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-heading text-lg text-navy-900">Professional CA Support</div>
                    <div className="text-sm text-navy-800/70">Real people. Real accountability.</div>
                  </div>
                  <span className="badge border-gold-500/30 bg-gold-50 text-navy-900">PAN-India</span>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1554224154-22dec7ec8818?auto=format&fit=crop&w=1600&q=80"
                  alt="Chartered accountant consultation in office"
                  className="h-72 sm:h-80 w-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <div className="rounded-2xl bg-white/90 backdrop-blur border border-navy-900/10 p-4 shadow-soft">
                    <div className="grid grid-cols-3 gap-3 text-center">
                      <div>
                        <div className="font-heading text-xl text-navy-900">4.9★</div>
                        <div className="text-xs text-navy-800/70">Google Rating</div>
                      </div>
                      <div>
                        <div className="font-heading text-xl text-navy-900">24–48h</div>
                        <div className="text-xs text-navy-800/70">Typical Turnaround</div>
                      </div>
                      <div>
                        <div className="font-heading text-xl text-navy-900">Zero</div>
                        <div className="text-xs text-navy-800/70">Hidden Charges</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p className="mt-3 text-xs text-navy-800/60">
              *Replace image + firm details anytime. This layout is optimized for mobile-first trust and conversions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
